import { trpcReact, trpcClient } from '@src/data/trpc.js';
import { queryClient } from './query.js';

const TRPCProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <trpcReact.Provider client={trpcClient} queryClient={queryClient}>
      {children}
    </trpcReact.Provider>
  );
};

export default TRPCProvider;
